import { render, staticRenderFns } from "./ModalSelectMaterial.vue?vue&type=template&id=0cdba141&scoped=true"
import script from "./ModalSelectMaterial.vue?vue&type=script&lang=js"
export * from "./ModalSelectMaterial.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectMaterial.vue?vue&type=style&index=0&id=0cdba141&prod&scoped=true&lang=scss"
import style1 from "./ModalSelectMaterial.vue?vue&type=style&index=1&id=0cdba141&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdba141",
  null
  
)

export default component.exports